export default __webpack_public_path__ + "static/media/104-tile.e248cbea.svg";